import router from '@/router'
import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { encrypt } from '@/utils/rsaEncrypt'
import {
  getKey,
  getToken
} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import {
  buildMenus
} from '@/api/system/menu'
import {
  filterAsyncRouter
} from '@/store/modules/permission'
import {
  isMobile,
  changeFavicon
} from '@/utils/index'
import Layout from '@/layout/index'
import { getSysUI } from '@/utils/auth'

import { getSocket } from '@/websocket'
import { getPublicKey } from '@/api/user'
import Cookies from 'js-cookie'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = ['/login', '/401', '/404', '/delink', '/nolic','/de-auto-login'] // no redirect whitelist

const routeBefore = (callBack) => {

/*   console.log("getRolesId")
  let Authorization=getKey("Authorization");
  if(Authorization){
    //判断
    store.dispatch('user/getRolesId').then(response => {
      console.log(response)
      if(response!=null){
        let roleids =response.roleids
        let user_id= response.id
        console.log(user_id)
        if(user_id!=1){
          if(roleids==null || roleids==''){
            return  window.location.href= '/#/preview/bfbf9d74-f5f2-11ed-b281-db66c29b9542'
          }else{
            let arr = roleids.split(",");
            console.log(arr)
            if (!arr.includes('171')) {
              console.log('ffff')
              return  window.location.href= '/#/preview/bfbf9d74-f5f2-11ed-b281-db66c29b9542'
            }
          }
        }
      }
    })
  } */

  let uiInfo = getSysUI()
  if (!uiInfo || Object.keys(uiInfo).length === 0) {
    store.dispatch('user/getUI').then(() => {
      document.title = getPageTitle()
      uiInfo = getSysUI()
      if (uiInfo['ui.favicon'] && uiInfo['ui.favicon'].paramValue) {
        const faviconUrl = '/system/ui/image/' + uiInfo['ui.favicon'].paramValue
        changeFavicon(faviconUrl)
      }
      callBack()
    }).catch(err => {
      document.title = getPageTitle()
      console.error(err)
      callBack()
    })
  } else {
    document.title = getPageTitle()
    if (!!uiInfo && uiInfo['ui.favicon'] && uiInfo['ui.favicon'].paramValue) {
      const faviconUrl = '/system/ui/image/' + uiInfo['ui.favicon'].paramValue
      changeFavicon(faviconUrl)
    }
    callBack()
  }
}
router.beforeEach(async(to, from, next) => routeBefore(() => {
  // start progress bar
  NProgress.start()
  const mobileIgnores = ['/delink', '/de-auto-login']
  const mobilePreview = '/preview/'
  const hasToken = getToken()

  if (isMobile() && !to.path.includes(mobilePreview) && mobileIgnores.indexOf(to.path) === -1) {
    let urlSuffix = '/app.html'
    if (hasToken) {
      urlSuffix += ('?detoken=' + hasToken)
    }
    localStorage.removeItem('user-info')
    localStorage.removeItem('userId')
    localStorage.removeItem('Authorization')
    window.location.href = window.origin + urlSuffix
    NProgress.done()
  }

  // set page title
  document.title = getPageTitle(to.meta.title)
  let base = window.location.href.split("#")[1].split("?")[1];
  let bid2 = window.location.href.split("#")[1].split("?")[0];
  console.log(base)
  if(typeof base !=='undefined'){
    let languageidweaver=getKey("languageidweaver");
    console.log("cookie---")
    console.log(languageidweaver)

    localStorage.setItem("preview", bid2)
    if(languageidweaver==8){
      Cookies.set('language', 'en_US')
      localStorage.setItem("language", 'en_US')
    }else{
      Cookies.set('language', 'zh_CN')
      localStorage.setItem("language", 'zh_CN')
    }
  }
  const currentLanguage = Cookies.get('language')
  if(String(currentLanguage) === 'null'){
    const storageLanguage = localStorage.getItem('language')
    if(String(storageLanguage) === 'null'){
      Cookies.set('language', 'zh_CN')
      localStorage.setItem("language", 'zh_CN')
    }else{
      Cookies.set('language', storageLanguage)
    }
  }
  // determine whether the user has logged in
  console.log(hasToken)
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({
        path: '/'
      })

    } else {
      const hasGetUserInfo = store.getters.name
      if (hasGetUserInfo || to.path.indexOf('/previewScreenShot/') > -1 || to.path.indexOf('/preview/') > -1 || to.path.indexOf('/delink') > -1 || to.path.indexOf('/nolic') > -1) {
        next()
        store.dispatch('permission/setCurrentPath', to.path)
      } else {


        if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
          // get user info
          store.dispatch('user/getInfo').then(() => {
            const deWebsocket = getSocket()
            deWebsocket && deWebsocket.reconnect && deWebsocket.reconnect()
            store.dispatch('lic/getLicInfo').then(() => {
              loadMenus(next, to)
            }).catch(() => {
              loadMenus(next, to)
            })
          }).catch(() => {
            store.dispatch('user/logout').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          })
        } else if (store.getters.loadMenus) {
          // 修改成false，防止死循环
          store.dispatch('user/updateLoadMenus')
          store.dispatch('lic/getLicInfo').then(() => {
            loadMenus(next, to)
          }).catch(() => {
            loadMenus(next, to)
          })
        } else {
          next()
        }
      }
    }
  } else if(to.path.indexOf('/preview')!==-1) {
      console.log(window.location.href)
      let base = window.location.href.split("#")[1].split("?")[1];
      console.log(base)
      let bid = window.location.href.split("#")[1].split("?")[0];
      if (typeof base !=='undefined') {
        let ck = base.split("&");
        if (ck[0] || ck[1]) {
          let hqtsToken = ck[0].split("=")[1];
          let token2 = ck[1].split("=")[1];
          console.log("token222222222222222")
          console.log(hqtsToken, token2)
          localStorage.setItem("hqtsToken", hqtsToken)
          localStorage.setItem("token2", token2)
          localStorage.setItem("preview", bid)
          let username = hqtsToken;
          let password = token2;
          const user = {
            username: encrypt(username),
            password: encrypt(password),
            loginType: 2
          }
          store.dispatch('user/login', user).then(response => {
            const {data} = response
            setToken(data.token)

          }).catch(() => {

            next()

          })

        } else {
          next()
        }
      } else {
        next()
      }
    }else {

      if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
        next()
       } else {
      // other pages that do not have permission to access are redirected to the login page.
      // next(`/login?redirect=${to.path}`)
        next(`/login?redirect=${to.fullPath}`)
      NProgress.done()
    }
  }
}))
export const loadMenus = (next, to) => {
  buildMenus().then(res => {
    const data = res.data
    const filterData = filterRouter(data)
    const asyncRouter = filterAsyncRouter(filterData)
    // 如果包含首页 则默认页面是 首页 否则默认页面是仪表板页面

    let user_id=localStorage.getItem("userId")
    console.log("------------------")
    console.log(to.path)
    console.log(to.path.indexOf('/preview')===-1)
    if(user_id!=1){
      console.log('aaaaaaaaaaaa')
      console.log(user_id)
     // this.$store.dispatch('user/logout').then(() => {
      //  location.href="/#/login"
      //})

    }

    if (JSON.stringify(data).indexOf('wizard') > -1) {
      asyncRouter.push({
        path: '/',
        component: Layout,
        redirect: '/wizard/index',
        hidden: true
      })
    } else {
      asyncRouter.push({
        path: '/',
        component: Layout,
        redirect: '/panel/index',
        hidden: true
      })
    }

    asyncRouter.push({
      path: '*',
      redirect: '/404',
      hidden: true
    })
    store.dispatch('permission/GenerateRoutes', asyncRouter).then(() => { // 存储路由
      router.addRoutes(asyncRouter)
      if (pathValid(to.path, asyncRouter)) {
        next({
          ...to,
          replace: true
        })
      } else {
        next('/')
      }
    })
  })
}

/**
 * 验证path是否有效
 * @param {*} path
 * @param {*} routers
 * @returns
 */
const pathValid = (path, routers) => {
  const temp = path.startsWith('/') ? path.substr(1) : path
  const locations = temp.split('/')
  if (locations.length === 0) {
    return false
  }

  return hasCurrentRouter(locations, routers, 0)
}
/**
 * 递归验证every level
 * @param {*} locations
 * @param {*} routers
 * @param {*} index
 * @returns
 */
const hasCurrentRouter = (locations, routers, index) => {
  const location = locations[index]
  let kids = []
  const isvalid = routers.some(router => {
    kids = router.children
    return (router.path === location || ('/' + location) === router.path)
  })
  if (isvalid && index < locations.length - 1) {
    return hasCurrentRouter(locations, kids, index + 1)
  }
  return isvalid
}
// 根据权限过滤菜单
const filterRouter = routers => {
  const user_permissions = store.getters.permissions
  // if (!user_permissions || user_permissions.length === 0) {
  //   return routers
  // }
  const tempResults = routers.filter(router => hasPermission(router, user_permissions))
  // 如果是一级菜单(目录) 没有字菜单 那就移除
  return tempResults.filter(item => {
    if (item.type === 0 && (!item.children || item.children.length === 0)) {
      return false
    }
    return true
  })
}
const hasPermission = (router, user_permissions) => {
  // 判断是否有符合权限 eg. user:read,user:delete
  if (router.permission && router.permission.indexOf(',') > -1) {
    const permissions = router.permission.split(',')
    const permissionsFilter = permissions.filter(permission => {
      return user_permissions.includes(permission)
    })
    if (!permissionsFilter || permissionsFilter.length === 0) {
      return false
    }
  } else if (router.permission && !user_permissions.includes(router.permission)) {
    // 菜单要求权限 但是当前用户权限没有包含菜单权限
    return false
  }

  if (!filterLic(router)) {
    return false
  }
  // 如果有字菜单 则 判断是否满足 ‘任意一个子菜单有权限’
  if (router.children && router.children.length) {
    const permissionChildren = router.children.filter(item => hasPermission(item, user_permissions))
    router.children = permissionChildren
    return router.children.length > 0
  }
  return true
}
const filterLic = (router) => {
  return !router.isPlugin || store.getters.validate
}
router.afterEach(() => {
  // finish progress bar

   console.log("afterEach")
  let Authorization=getKey("Authorization");
  if(Authorization) {
    //判断
    store.dispatch('user/getRolesId').then(response => {
      console.log(response)
      if (response != null) {
        let roleids = response.roleids
        let szbms = response.szbms
        let ywxs = response.ywxs
        let szjgs = response.szjgs === null ? "" : response.szjgs
        let user_id = response.id
        let jgnames = response.jgnames === null ? "" : response.jgnames
        let ar_id = response.ar_id
        let ar_jgs = response.ar_jgs


        if (jgnames) {
          localStorage.setItem("jgnames", jgnames)
        }
        let ywxnames = response.ywxnames
        if (ywxnames) {
          localStorage.setItem("ywxnames", ywxnames)
        }
        localStorage.removeItem("chanage_name")
        console.log("roleids---------------")
        console.log(user_id, roleids)
        let surl = window.location.href.split("preview/")[1];
        console.log(surl)
        if (user_id != 1 && surl!="bfbf9d74-f5f2-11ed-b281-db66c29b9542") {
           if (roleids == null || roleids == '') {
             return window.location.href = '/#/preview/bfbf9d74-f5f2-11ed-b281-db66c29b9542'
           } else {
             let roleids_arr = roleids.split(",");
             let szjgs_arr = szjgs.split(",");
             //没有BI-171权限
             if (!roleids_arr.includes('171')) {
               return window.location.href = '/#/preview/bfbf9d74-f5f2-11ed-b281-db66c29b9542'
             } else {
               //是否获取有30集团总裁办的机构，假设没有就跳转到机构页面
               if (!szjgs_arr.includes('30')) {
                 let preview = localStorage.getItem('preview');
                 localStorage.setItem("is_master", false)
                 //经营分析
                 if (preview == '/preview/8bca5a6e-3d6c-11ed-b0f5-094446457ac3') {
                   //判断区域负责人
                   let is_region = false
                   if (ar_id == null || ar_id == "" || typeof ar_id === 'undefined') {
                     localStorage.setItem("is_region", is_region)
                   } else {
                     is_region = true
                     localStorage.setItem("is_region", is_region)
                     localStorage.setItem("ar_ids", ar_id)
                     localStorage.setItem("ar_jgs", ar_jgs)
                   }
                   console.log("is_region--------------------------")
                   console.log(is_region)
                   if (szjgs == "") {
                     return window.location.href = '/#/preview/bfbf9d74-f5f2-11ed-b281-db66c29b9542'
                   }
                   if (!is_region) {
                     console.log('111111111111111')
                     console.log(is_region)
                     let hqtsToken = localStorage.getItem("hqtsToken")
                     let token2 = localStorage.getItem("token2")

                     return window.location.href = '/#/preview/f176aa21-d2b6-11ed-9df3-09ecbf5450a3' + '?hqtsToken=' + hqtsToken + '&' + 'token2=' + token2
                   }


                 }
               } else {
                 localStorage.setItem("is_master", true)
               }
             }
           //}
         }
        }
      }
    //}).catch(() => {
        //过期authorization
      //console.log("authorization------")
     //  return window.location.href = '/#/preview/bfbf9d74-f5f2-11ed-b281-db66c29b9542'
    })
  }

  NProgress.done()
})
